import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personHealthProfileApi } from '../../services/personHealthProfileApi';
import { personHealthProfileKeys } from './useGetPersonHealthProfile';
import { personKeys } from '../Person/useGetPerson';

export function useDeletePersonHealthProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => personHealthProfileApi.deletePersonHealthProfile(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted health profile');
        // Invalidate both personHealthProfile and person queries
        queryClient.invalidateQueries({ queryKey: personHealthProfileKeys.all });
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete health profile'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete health profile'}`);
    },
  });
}
